import Modal from "react-bootstrap/Modal";
import { AvailabilityAddNew } from "../components/AvailabilityAddNew";

export const AvailabilityNewModal = ({
  visible,
  close,
  pageHeaderMsg,
  forceUpdate,
  editOrNew,
  user = null,
}) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <h2>Add New Availability</h2>
      </Modal.Header>
      <Modal.Body>
        <AvailabilityAddNew
          close={close}
          pageHeaderMsg={pageHeaderMsg}
          forceUpdate={forceUpdate}
          editOrNew={editOrNew}
          selectUser={user}
        />
      </Modal.Body>
    </Modal>
  );
};
